import { state } from "@src/state";
export function restoreStudioData() {
    state.meeting.studio.restoreStudio();
}
export function mapRetrievalSource(source) {
    void state.meeting.studio.mapRetrievalSource(source);
}
